import React from 'react';
import { useAuthContext } from '../../../contexts/AuthContext';
import LoginButton from '../../../components/auth/LoginButton';
import { LoadingSpinner } from '@components/common';
import './LoginPage.scss';

const LoginPage = () => {
    const { login, loading, error } = useAuthContext();

    if (loading) {
        return <LoadingSpinner message="Checking authentication..." />;
    }

    return (
        <div className="login-page">
            <div className="login-page__container">
                <h1>Welcome</h1>
                <p>Please log in with your Nextcloud account to continue.</p>

                {error && (
                    <div className="login-page__error">
                        {error}
                    </div>
                )}

                <LoginButton onLogin={login} />
            </div>
        </div>
    );
};

export default LoginPage;